module.exports = __webpack_public_path__ + "img/三体.0c784483.png";